export default __webpack_public_path__ + "static/media/Empty-state-2.48052809.svg";